import React from "react";
import GuideHeader from "../Guide/GuideHeader";
import "./GuideScheduling.css";

const GuideScheduling = () => {
  const tips = [
    {
      number: 1,
      title: "The best day",
      text: `Most research suggests that Monday to Thursday are the best days of the week to send an email – and apparently sending on a Tuesday can result in a 10% higher open rate than any other weekday. Typically, weekend sends perform the worst.`,
    },
    {
      number: 2,
      title: "The best time",
      text: `The time of day is also important, and we see that between 10 am and 2 pm is often the best time.`,
    },
    {
      number: 3,
      title: "Test, test, test!",
      text: `All industries, businesses and audiences are different – so the best advice is to keep testing to see what works best for you.`,
    },
    {
      number: 4,
      title: "Take timezones into account",
      text: `If you have a global subscriber base, don’t forget to take their timezone into account. You can create a different list for each timezone and schedule your campaigns accordingly.`,
    },
    {
      number: 5,
      title: "Keep it consistent",
      text: `Once you have found a regular send pattern, it’s best that your subscribers know when to expect your emails. Consistency builds trust and anticipation.`,
    },
    {
      number: 6,
      title: "Schedule your emails in advance",
      text: `You can use the scheduling feature in Mailsnappy to set your campaigns to send at any date, time and timezone – so with a little testing, it’s easy to find the right day and time that works best for your marketing strategy.`,
    },
  ];

  return (
    <div className="guide-page">
      {/* ✅ Shared Header */}
      <GuideHeader headingLevel="div" />

      {/* 📧 Content Section */}
      <section className="scheduling-content">
        <h1>Tips for scheduling your email campaigns</h1>
        <p className="intro-text">
          If you’re new to email marketing you might be keen to send your first campaign as quickly as possible. 
          But did you know that different times of the day are better than others for improving your open rates? 
          Picking the right time will mean that more people are likely to read your email.
        </p>

        <div className="scheduling-tips">
          {tips.map((tip) => (
            <div key={tip.number} className="tip-box">
              <div className="tip-number">{tip.number}</div>
              <div className="tip-content">
                <h3>{tip.title}</h3>
                <p>{tip.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="next-step">
          <p>
            Almost there! You’ve scheduled your email, now for the final step of analysing it.
          </p>
          <p className="next-link">
            Read how to <a href="/guide">measure the success of your emails →</a>
          </p>
        </div>
      </section>

      {/* 🌊 CTA Section */}
      <section className="guide-start">
        <h2>Start for free today</h2>
        <p>Sign up and send your first campaign in minutes. No credit card required.</p>
      </section>
    </div>
  );
};

export default GuideScheduling;
